module.exports = __webpack_public_path__ + "img/title-3.97b7d04e.png";